// material-ui
import { styled } from '@mui/material/styles';

// ==============================|| WRAPPER ||============================== //

export const MinimalWrapper = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.light : theme.palette.background.default,
    minHeight: '100vh'
}));
